var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-draw-view", style: _vm.computedStyles },
    [
      _c("canvas", {
        ref: "canvas",
        style: _vm.objectStyle,
        attrs: { height: _vm.canvasHeight, width: _vm.canvasWidth },
      }),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isCanvasOverlayActive,
            expression: "isCanvasOverlayActive",
          },
        ],
        staticClass: "editor-draw-view-canvas-overlay",
        style: _vm.objectStyle,
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }